"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledModalButton = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
//
// properties
//
const config_1 = require("../../../assets/styles/config");
exports.StyledModalButton = styled_components_1.default.button `
  align-items: center;
  background: ${config_1.colors.white};
  border: 1px solid ${config_1.colors.huron};
  border-radius: 2px;
  display: flex;
  font: ${config_1.fontSizes.tiny} ${config_1.fontFamilies.primary};
  height: 20px;
  justify-content: center;
  margin: 0 10px;
  width: 37px;

  &:hover,
  &:focus {
    background: ${config_1.colors.blurple};
    color: ${config_1.colors.white};
  }
`;
